import { render } from "./ClientHistoryDialog.vue?vue&type=template&id=505dfd77&scoped=true"
import script from "./ClientHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./ClientHistoryDialog.vue?vue&type=script&lang=ts"

import "./ClientHistoryDialog.vue?vue&type=style&index=0&id=505dfd77&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-505dfd77"

export default script